import { render } from "./Endpoint.vue?vue&type=template&id=c4d73144"
import script from "./Endpoint.vue?vue&type=script&lang=js"
export * from "./Endpoint.vue?vue&type=script&lang=js"

import "./Endpoint.vue?vue&type=style&index=0&id=c4d73144&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__